import React from 'react'
import injectJss from 'react-jss'
import compose from 'recompose/compose'
import exclaimation from 'public/assets/svg/exclaimation.svg'
import close from 'public/assets/svg/close-button.svg'

const styleSheet = theme => ({
    container: {
        position: 'fixed',
        height: ({ height }) => height,
        width: ({ width }) => width,
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        backgroundColor: '#085FE5',
        zIndex: 10000,
        left: '50%',
        transform: 'translateX(-50%)',
    },
    bannerText: {
        color: 'white',
        width: 439,
        fontSize: 18,
    },
    closeBtn: {
        cursor: 'pointer',
        background: 'none',
        outline: 'none',
        padding: 0,
        border: 0,
        top: 10,
        right: 10,
        position: 'absolute',
    },
    exclaimation: {
        marginBottom: 25,
    },
})

const style = injectJss(styleSheet)

const TourInProgressBanner = ({ classes, bannerText, onClick }) => (
    <div className={classes.container}>
        <img className={classes.exclaimation} src={exclaimation} />

        <div className={classes.bannerText}>{bannerText}</div>

        <button onClick={onClick} type="button" className={classes.closeBtn}>
            <img src={close} />
        </button>
    </div>
)

TourInProgressBanner.defaultProps = {
    bannerText: 'Work in progress. Please work with your YouVisit team to remove this banner prior to going live',
    width: 516,
    height: 75,
}

export default compose(style)(TourInProgressBanner)
